import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { jsPDF } from 'jspdf';
import domtoimage from 'dom-to-image';

@Component({
  selector: 'app-listado-qrs',
  templateUrl: './listado-qrs.component.html',
  styleUrls: ['./listado-qrs.component.scss'],
})
export class ListadoQrsComponent implements OnInit {
  // @ViewChild('pdfTable') pdfTable: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any[],
    private dialogRef: MatDialogRef<ListadoQrsComponent>
  ) {}

  ngOnInit(): void {
    console.log('los datos son: ', this.data);
  }

  public downloadAsPDF() {
    const dashboard = document.getElementById('divContenedor');
    if (dashboard != null) {
      const dashboardHeight = dashboard.clientHeight;
      const dashboardWidth = dashboard.clientWidth;
      const options = {
        background: 'white',
        width: dashboardWidth,
        height: dashboardHeight,
      };

      domtoimage.toPng(dashboard, options).then((imgData) => {
        const doc = new jsPDF(
          dashboardWidth > dashboardHeight ? 'l' : 'p',
          'mm',
          [dashboardWidth, dashboardHeight]
        );
        const imgProps = doc.getImageProperties(imgData);
        const pdfWidth = doc.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        doc.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        doc.save('codigosQrs.pdf');
      });
    }
  }
}
